import { render } from "./TutupOutlet.vue?vue&type=template&id=10131486&scoped=true"
import script from "./TutupOutlet.vue?vue&type=script&lang=js"
export * from "./TutupOutlet.vue?vue&type=script&lang=js"

import "./TutupOutlet.vue?vue&type=style&index=0&id=10131486&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10131486"

export default script